+function ($) {
    'use strict';

    var JumperPanel = function (element, option) {
        this.$element = $(element);
        var urlBackground = this.$element.data('background');
        this.$element.css('background-image', 'url("'+urlBackground+'")');
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            new JumperPanel(this, options);
        });
    };



    var old = $.fn.jumperPanel;

    $.fn.jumperPanel = constructor;
    $.fn.jumperPanel.constructor = constructor;

    $.fn.jumperPanel.noConflict = function () {
        $.fn.jumperPanel = old;
        return this;
    }
}(jQuery);